import React from 'react';

export const CalendarIcon: React.FC<sharedComponents.SvgIcon> = ({ height = 32, width = 32, className = '' }) => (
  <svg
    width={`${width}px`}
    height={`${height}px`}
    viewBox="0 0 32 32"
    className={className}
  >
    <path d="M27 8V27H5V8H27ZM27 7H5C4.4 7 4 7.4 4 8V27C4 27.5 4.4 28 5 28H27C27.6 28 28 27.5 28 27V8C28 7.4 27.6 7 27 7Z" fill="#2A2A2A" />
    <path fillRule="evenodd" clipRule="evenodd" d="M4 12.5C4 12.2239 4.22386 12 4.5 12H27.5C27.7761 12 28 12.2239 28 12.5C28 12.7761 27.7761 13 27.5 13H4.5C4.22386 13 4 12.7761 4 12.5Z" fill="#2A2A2A" />
    <path fillRule="evenodd" clipRule="evenodd" d="M7.5 4C7.77614 4 8 4.22386 8 4.5V8.5C8 8.77614 7.77614 9 7.5 9C7.22386 9 7 8.77614 7 8.5V4.5C7 4.22386 7.22386 4 7.5 4Z" fill="#2A2A2A" />
    <path fillRule="evenodd" clipRule="evenodd" d="M24.5 4C24.7761 4 25 4.22386 25 4.5V8.5C25 8.77614 24.7761 9 24.5 9C24.2239 9 24 8.77614 24 8.5V4.5C24 4.22386 24.2239 4 24.5 4Z" fill="#2A2A2A" />
  </svg>
);
